export const fmt = 'HH:mm:ss, MMM DD YYYY';
